import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useService } from '../../../../../../services/services';

export const FIELD_STORED = {
  LOCAL: 'LOCAL',
  LAD: 'LAD',
} as const;

export const useTable = <T>() => {
  const { t } = useTranslation();
  const transKeyPrefix = 'pages.crop.fields_and_works.fields.sync.';
  const tp = useCallback((key: string) => t(transKeyPrefix.concat(key)), [t]);
  const { farmId, season } = useParams<{ farmId: string; season: string }>();
  const { fieldService } = useService();
  const selectedFields = useState<T[]>([]);

  return {
    selectedFields,
    t,
    tp,
    farmId,
    season,
    fieldService,
  };
};
